module.exports = __webpack_public_path__ + "img/lg23.e72dd43a.png";